import { isEmpty , assign } from "lodash";

export function extract_available_plugins(templates) {

    let plugins = [];

    for (const template of templates) {


        if (!isEmpty(template.data.reqPlugins)) {


           plugins = assign(plugins, extract_plugin_name(template.data.reqPlugins));

        }


    }

    return plugins;


}

export function extract_plugin_name(plugin_list) {
    return plugin_list.map(plugin => {
        return plugin.split(" || ")[0]
    });
}

export function camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }

export function camelizePluginList(p_list) {
    return p_list.map(p => camelize(p));
}